import React from 'react'

import CoverArtItem from '@components/music/CoverArtItem'
import GridContainer from '@containers/GridContainer'
import { TitleType } from '@models/Title'

import { getPaginationLink } from './utils'

interface Props {
  titles: TitleType[]
  startPage: number
}

const GridResults: React.FC<Props> = ({ titles, startPage }: Props) => (
  <GridContainer>
    {titles.map((title, index) => (
      <CoverArtItem
        title={title}
        key={`title-${title.uuid}`}
        data-testid="Card"
        paginationNumLink={getPaginationLink(index, startPage)}
      />
    ))}
  </GridContainer>
)

export default GridResults
